import { Api } from './Api';
import axios from 'axios';

export class AuthService {
   
    private static textEncoder = new TextEncoder();
    private static textDecoder = new TextDecoder();
    
    private static deriveKey = async (password: string, salt: Uint8Array) => {
      const keyMaterial = await window.crypto.subtle.importKey(
        "raw",
        this.textEncoder.encode(password),
        { name: "PBKDF2" },
        false,
        ["deriveKey"]
      );
    
      return window.crypto.subtle.deriveKey(
        {
          name: "PBKDF2",
          salt: salt,
          iterations: 100000,
          hash: "SHA-256",
        },
        keyMaterial,
        { name: "AES-GCM", length: 256 },
        false,
        ["encrypt", "decrypt"]
      );
    } 

    // Encrypt the string
    public static encryptData = async (password: string, data: string, category: string) => {
        const salt = window.crypto.getRandomValues(new Uint8Array(16)); 
        const iv = window.crypto.getRandomValues(new Uint8Array(12)); 
        const key = await this.deriveKey(password, salt);

        const encryptedData = await window.crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv: iv,
        },
        key,
        this.textEncoder.encode(data)
        );
    
        // base 46
        const encryptedBase64 = btoa(String.fromCharCode(...new Uint8Array(encryptedData)));
    
        const storageObject = {
            encrypted: encryptedBase64,
            salt: Array.from(salt),
            iv: Array.from(iv),
        };
    
        localStorage.setItem(category, JSON.stringify(storageObject));

        return new Promise((resolve) => { resolve(true) })
    }

    // Decrypt 
    public static decryptData = async (password: string, category: string) => {

        if (!password) throw new Error("Erro - sem password." + password);
        
        const storageItem = localStorage.getItem(category);
    
        if (!storageItem) throw new Error("Erro - sem localstorage");
        
        const { encrypted, salt, iv } = JSON.parse(storageItem);
        const key = await this.deriveKey(password, new Uint8Array(salt));
    
        const encryptedArrayBuffer = Uint8Array.from(atob(encrypted), (c) => c.charCodeAt(0));
    
        const decryptedData = await window.crypto.subtle.decrypt(
            {
                name: "AES-GCM",
                iv: new Uint8Array(iv),
            },
            key,
            encryptedArrayBuffer
        );
        
        return this.textDecoder.decode(decryptedData);
    }         

    public static checkLoginData = async (): Promise<boolean> => {
        
        await AuthService.getIp();

        if (localStorage.getItem('encryptAt') && localStorage.getItem('encryptRt')) {
            return new Promise( resolve => resolve(true));
        } 
        return new Promise( resolve => resolve(false));
    }

    public static getIp = async () : Promise<boolean> => {
        const resIp = await axios.get("https://api.ipify.org/?format=json");
        Api.setIpAddress(resIp.data.ip);
        return true;
    }

    // Status Control

    // APIs
    public static login = async (id: any): Promise<string | void> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/signin`;
        });
        return Api.post<void>(`${target}`, {device_id: id});
    }

    public static signup = async (payload: any): Promise<void> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/signup`;
        });
        return Api.post<void>(`${target}`, {flow: 'device', device_id:payload});
    }

    public static refreshAppStatus = async (rt:string): Promise<void> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/refresh`;
        });
        return Api.post<void>(`${target}`, rt)
    }

}